import { Component, Input } from '@angular/core';
import { ZoningCode, ZoningCodeVersion } from 'src/app/modules/instance/models';
import { InstanceService, TaskService } from 'src/app/modules/instance/services';
import { ZoningCodeVersionButtons } from 'src/app/modules/instance/models';
import { IDetailsData } from 'src/app/shared/interfaces/details-data';

@Component({
    standalone: false,
    selector: 'app-zoning-code-version-calculate-button',
    templateUrl: './zoning-code-version-calculate-button.component.html',
    styleUrls: ['./zoning-code-version-calculate-button.component.scss']
})
export class zoningCodeVersionCalculateButtonComponent extends ZoningCodeVersionButtons {
    constructor(
        private readonly instanceService: InstanceService,
        private readonly taskService: TaskService
    ) {
        super();
    }

    @Input()
    public zoningCode: ZoningCode;

    @Input()
    public zoningCodeVersion: ZoningCodeVersion;

    @Input()
    public detailsData: IDetailsData;

    public calculateZCVersion(event: Event) {
        if (!this.instanceService.selectedInstance || !this.zoningCodeVersion) {
            return;
        }

        if (this.isCalculating) {
            return;
        }

        this.taskService.calculateZCVersion(this.instanceService.selectedInstance.Id, this.zoningCodeVersion.Id, this.zoningCode.GridicsId)
            .subscribe();

        event.stopPropagation();
    }

    get isCalculating() {
        return this.zoningCodeVersion.CalculationTask && this.zoningCodeVersion.CalculationTask.canStart === false;
    }

}

